// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Public Restaurant Menu Mobile-First Styles */

.public-restaurant-menu {
    min-height: 100vh;
    background-color: #f8f9fa;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

/* Header Styles */
.menu-header {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1020;
}

.store-logo {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
}

.store-name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

/* Search Input */
.search-input {
    border-radius: 25px;
    padding: 12px 20px;
    border: 1px solid #ddd;
    font-size: 16px;
    /* Prevents zoom on iOS */
}

.search-input:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Category Pills */
.category-pills {
    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
}

.category-pills .overflow-auto::-webkit-scrollbar {
    display: none;
}

.category-pills .overflow-auto {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

/* Product Cards */
.product-card {
    transition: all 0.2s ease;
    background: white;
}

.product-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.product-title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    line-height: 1.3;
}

.product-price .currency {
    font-size: 12px;
    color: #666;
}

.product-price .amount {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.add-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

/* Category Title */
.category-title {
    font-size: 18px;
    font-weight: 700;
    color: #333;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid #007bff;
}

/* Cart Styles */
.cart-item {
    background: white;
    transition: all 0.2s ease;
}

.cart-summary {
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.cart-summary .d-flex {
    font-size: 15px;
}

.cart-summary .fw-bold {
    border-top: 2px solid #007bff;
    padding-top: 12px;
    margin-top: 8px;
}

/* Order Success */
.order-number {
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

/* Form Styles */
.form-label {
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
}

.form-control {
    border-radius: 8px;
    border: 1px solid #ddd;
    padding: 12px 16px;
    font-size: 16px;
    /* Prevents zoom on iOS */
}

.form-control:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-check-input:checked {
    background-color: #007bff;
    border-color: #007bff;
}

/* Button Styles */
.btn-primary {
    background-color: #007bff;
    border-color: #007bff;
    border-radius: 8px;
    padding: 12px 24px;
    font-weight: 600;
    transition: all 0.2s ease;
}

.btn-primary:hover {
    background-color: #0056b3;
    border-color: #0056b3;
    transform: translateY(-1px);
}

.btn-outline-primary {
    border-color: #007bff;
    color: #007bff;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.btn-outline-primary:hover {
    background-color: #007bff;
    border-color: #007bff;
    transform: translateY(-1px);
}

/* Badge Styles */
.badge {
    font-size: 11px;
    padding: 4px 8px;
}

.badge.bg-success {
    background-color: #28a745 !important;
}

.badge.bg-danger {
    background-color: #dc3545 !important;
}

/* Loading Spinner */
.spinner-border {
    width: 3rem;
    height: 3rem;
}

/* Responsive Design */
@media (max-width: 576px) {
    .container-fluid {
        padding: 0;
    }

    .menu-header {
        padding: 12px 16px;
    }

    .store-name {
        font-size: 14px;
    }

    .category-title {
        font-size: 16px;
    }

    .product-title {
        font-size: 14px;
    }

    .product-price .amount {
        font-size: 15px;
    }

    .add-btn {
        width: 32px;
        height: 32px;
    }

    .cart-summary .d-flex {
        font-size: 14px;
    }

    .btn-primary {
        padding: 14px 24px;
        font-size: 16px;
    }
}

@media (max-width: 480px) {
    .menu-header {
        padding: 10px 12px;
    }

    .store-logo {
        width: 28px;
        height: 28px;
    }

    .store-name {
        font-size: 13px;
    }

    .search-input {
        padding: 10px 16px;
        font-size: 16px;
    }

    .product-card .card-body {
        padding: 12px;
    }

    .cart-view {
        padding: 12px;
    }

    .cart-item .card-body {
        padding: 12px;
    }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
    .public-restaurant-menu {
        background-color: #1a1a1a;
        color: #ffffff;
    }

    .menu-header,
    .product-card,
    .cart-item {
        background-color: #2d2d2d;
        border-color: #404040;
    }

    .store-name,
    .product-title,
    .category-title {
        color: #ffffff;
    }

    .text-muted {
        color: #adb5bd !important;
    }

    .form-control {
        background-color: #2d2d2d;
        border-color: #404040;
        color: #ffffff;
    }

    .form-control:focus {
        background-color: #2d2d2d;
        border-color: #007bff;
        color: #ffffff;
    }
}

/* Accessibility improvements */
.btn:focus,
.form-control:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
}

/* Touch-friendly tap targets */
/* .btn,
.form-control,
.badge {
    min-height: 44px;
    min-width: 44px;
}

.add-btn,
.btn-sm {
    min-height: 36px;
    min-width: 36px;
} */

/* Smooth scrolling */
html {
    scroll-behavior: smooth;
}

/* Hide scrollbars but keep functionality */
.overflow-auto::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

/* Animation for cart badge */
.badge {
    animation: pulse 0.3s ease-in-out;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }

    100% {
        transform: scale(1);
    }
}

/* Sticky positioning for better UX */
.sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
}

/* Loading states */
.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Success states */
.text-success {
    color: #28a745 !important;
}

/* Error states */
.text-danger {
    color: #dc3545 !important;
}

/* Card hover effects */
.card {
    transition: all 0.2s ease-in-out;
}

.card:hover {
    /* transform: translateY(-2px); */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Modal improvements for mobile */
@media (max-width: 576px) {
    .modal-dialog {
        margin: 0;
        height: 100vh;
        max-width: 100%;
    }

    .modal-content {
        height: 100vh;
        border-radius: 0;
    }

    .digitalMenuRoomModal>div>.modal-content {
        height: 35%;
    }

    .modal-body {
        padding: 20px 15px;
    }
}

/* ==========================================================================
   Mobile QR landing-page enhancements
   ========================================================================== */

@media (max-width: 768px) {
    .public-restaurant-menu {
        background-color: #ffffff;
    }

    .menu-header {
        position: sticky;
        top: 0;
        padding: 12px 16px;
        background: #ffffff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
        border-bottom: none;
    }

    .store-logo {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }

    .store-name {
        font-size: 17px;
        font-weight: 700;
        color: #1a1a2e;
    }

    .menu-header .btn-link {
        color: #4a4a68;
        font-size: 18px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: #f8f9fa;
        margin-right: 8px;
    }

    .menu-header .btn-link:last-child {
        margin-right: 0;
    }

    .search-input {
        border-radius: 12px;
        border: 1px solid #e9ecef;
        background: #ffffff;
        padding: 13px 18px;
        font-size: 16px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    }

    .category-pills {
        position: sticky;
        top: 66px;
        z-index: 1010;
        background: #ffffff;
        padding: 12px 16px;
        border-bottom: 1px solid #f1f3f5;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    .category-pills .badge {
        display: inline-flex;
        align-items: center;
        padding: 10px 16px;
        font-size: 13px;
        font-weight: 600;
        color: #495057;
        background: #f1f3f5;
        border: 1px solid transparent;
        transition: all 0.2s ease;
        text-decoration: none;
    }

    .category-pills .badge:hover,
    .category-pills .badge:active,
    .category-pills .badge:focus {
        color: #ffffff;
        background: #007bff;
        border-color: #007bff;
    }

    .menu-content {
        padding: 16px;
        padding-bottom: 100px;
    }

    .category-title {
        font-size: 18px;
        font-weight: 700;
        color: #1a1a2e;
        border-bottom: none;
        margin-bottom: 12px;
    }

    .product-card {
        border-radius: 14px;
        border: 1px solid #f1f3f5;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
        margin-bottom: 16px;
        overflow: hidden;
    }

    .product-card .card-body {
        padding: 14px;
    }

    .product-image img {
        width: 72px;
        height: 72px;
        border-radius: 10px;
        object-fit: cover;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    }

    .product-title {
        font-size: 15px;
        font-weight: 700;
        color: #1a1a2e;
        line-height: 1.35;
        margin-bottom: 6px;
    }

    .product-price .currency {
        font-size: 12px;
        color: #6c757d;
    }

    .product-price .amount {
        font-size: 17px;
        font-weight: 700;
        color: #212529;
    }

    .add-btn {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        font-size: 16px;
        box-shadow: 0 2px 6px rgba(0, 123, 255, 0.25);
    }

    .add-btn:active {
        transform: scale(0.95);
    }

    /* Floating cart bar */
    .cart-fab-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 12px 16px;
        background: #ffffff;
        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
        z-index: 1040;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #f1f3f5;
    }

    .cart-fab-bar .cart-info {
        display: flex;
        flex-direction: column;
        color: #1a1a2e;
    }

    .cart-fab-bar .cart-items-count {
        font-size: 13px;
        color: #6c757d;
    }

    .cart-fab-bar .cart-total-amount {
        font-size: 17px;
        font-weight: 700;
    }

    .cart-fab-bar .btn-primary {
        padding: 10px 22px;
        border-radius: 10px;
        font-weight: 700;
        font-size: 15px;
    }

    .cart-view .cart-item .card-body {
        padding: 16px;
    }

    .cart-summary {
        border-radius: 14px;
        background: #f8f9fa;
        border: 1px solid #f1f3f5;
        padding: 18px;
        margin-bottom: 20px;
    }

    .cart-summary .d-flex:last-child {
        border-top: 2px solid #dee2e6;
        padding-top: 14px;
    }

    .form-control {
        border-radius: 10px;
        padding: 12px 14px;
        font-size: 16px;
        border: 1px solid #e9ecef;
    }

    .form-check-input {
        width: 20px;
        height: 20px;
        margin-top: 0;
    }

    .form-check-label {
        font-size: 14px;
        margin-left: 4px;
    }

    .btn-primary {
        border-radius: 12px;
        padding: 14px;
        font-size: 16px;
        font-weight: 700;
    }
}

@media (max-width: 576px) {
    .menu-header {
        top: 0;
        padding: 10px 14px;
    }

    .category-pills {
        top: 62px;
        padding: 10px 14px;
    }

    .product-image img {
        width: 60px;
        height: 60px;
    }

    .product-title {
        font-size: 14px;
    }

    .product-price .amount {
        font-size: 16px;
    }

    .add-btn {
        width: 36px;
        height: 36px;
    }
}

/* Hide the original header cart badge on mobile, the floating bar takes over */
@media (max-width: 768px) {
    .menu-header .cart-trigger-mobile {
        display: none !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/V4/Modules/Restaurant/Pages/PublicRestaurantMenu.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,iBAAiB;IACjB,yBAAyB;IACzB,gFAAgF;AACpF;;AAEA,kBAAkB;AAClB;IACI,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA,mBAAmB;AACnB;IACI,0FAA0F;AAC9F;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,sBAAsB;AACtB;IACI;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;;;QAGI,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;;;QAGI,cAAc;IAClB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,cAAc;IAClB;AACJ;;AAEA,+BAA+B;AAC/B;;IAEI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;;;;;;;;;;;GAWG;;AAEH,qBAAqB;AACrB;IACI,uBAAuB;AAC3B;;AAEA,2CAA2C;AAC3C;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA,6BAA6B;AAC7B;IACI,iCAAiC;AACrC;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA,qCAAqC;AACrC;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;IACjC,0CAA0C;AAC9C;;AAEA,kCAAkC;AAClC;IACI;QACI,SAAS;QACT,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;;+EAE+E;;AAE/E;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,MAAM;QACN,kBAAkB;QAClB,mBAAmB;QACnB,0CAA0C;QAC1C,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yCAAyC;IAC7C;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,yCAAyC;IAC7C;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,gCAAgC;QAChC,yCAAyC;IAC7C;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,mBAAmB;QACnB,6BAA6B;QAC7B,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;;;QAGI,cAAc;QACd,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,0CAA0C;QAC1C,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,iBAAiB;QACjB,yCAAyC;IAC7C;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,6CAA6C;IACjD;;IAEA;QACI,sBAAsB;IAC1B;;IAEA,sBAAsB;IACtB;QACI,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,kBAAkB;QAClB,mBAAmB;QACnB,2CAA2C;QAC3C,aAAa;QACb,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,yBAAyB;QACzB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,MAAM;QACN,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,+EAA+E;AAC/E;IACI;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["/* Public Restaurant Menu Mobile-First Styles */\n\n.public-restaurant-menu {\n    min-height: 100vh;\n    background-color: #f8f9fa;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n}\n\n/* Header Styles */\n.menu-header {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    z-index: 1020;\n}\n\n.store-logo {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.store-name {\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n/* Search Input */\n.search-input {\n    border-radius: 25px;\n    padding: 12px 20px;\n    border: 1px solid #ddd;\n    font-size: 16px;\n    /* Prevents zoom on iOS */\n}\n\n.search-input:focus {\n    border-color: #007bff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n/* Category Pills */\n.category-pills {\n    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);\n}\n\n.category-pills .overflow-auto::-webkit-scrollbar {\n    display: none;\n}\n\n.category-pills .overflow-auto {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n}\n\n/* Product Cards */\n.product-card {\n    transition: all 0.2s ease;\n    background: white;\n}\n\n.product-card:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.product-title {\n    font-size: 15px;\n    font-weight: 600;\n    color: #333;\n    line-height: 1.3;\n}\n\n.product-price .currency {\n    font-size: 12px;\n    color: #666;\n}\n\n.product-price .amount {\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n.add-btn {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n}\n\n/* Category Title */\n.category-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #333;\n    margin-bottom: 16px;\n    padding-bottom: 8px;\n    border-bottom: 2px solid #007bff;\n}\n\n/* Cart Styles */\n.cart-item {\n    background: white;\n    transition: all 0.2s ease;\n}\n\n.cart-summary {\n    background: #f8f9fa;\n    padding: 16px;\n    border-radius: 8px;\n    border: 1px solid #e9ecef;\n}\n\n.cart-summary .d-flex {\n    font-size: 15px;\n}\n\n.cart-summary .fw-bold {\n    border-top: 2px solid #007bff;\n    padding-top: 12px;\n    margin-top: 8px;\n}\n\n/* Order Success */\n.order-number {\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n/* Form Styles */\n.form-label {\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 8px;\n}\n\n.form-control {\n    border-radius: 8px;\n    border: 1px solid #ddd;\n    padding: 12px 16px;\n    font-size: 16px;\n    /* Prevents zoom on iOS */\n}\n\n.form-control:focus {\n    border-color: #007bff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.form-check-input:checked {\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n/* Button Styles */\n.btn-primary {\n    background-color: #007bff;\n    border-color: #007bff;\n    border-radius: 8px;\n    padding: 12px 24px;\n    font-weight: 600;\n    transition: all 0.2s ease;\n}\n\n.btn-primary:hover {\n    background-color: #0056b3;\n    border-color: #0056b3;\n    transform: translateY(-1px);\n}\n\n.btn-outline-primary {\n    border-color: #007bff;\n    color: #007bff;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n}\n\n.btn-outline-primary:hover {\n    background-color: #007bff;\n    border-color: #007bff;\n    transform: translateY(-1px);\n}\n\n/* Badge Styles */\n.badge {\n    font-size: 11px;\n    padding: 4px 8px;\n}\n\n.badge.bg-success {\n    background-color: #28a745 !important;\n}\n\n.badge.bg-danger {\n    background-color: #dc3545 !important;\n}\n\n/* Loading Spinner */\n.spinner-border {\n    width: 3rem;\n    height: 3rem;\n}\n\n/* Responsive Design */\n@media (max-width: 576px) {\n    .container-fluid {\n        padding: 0;\n    }\n\n    .menu-header {\n        padding: 12px 16px;\n    }\n\n    .store-name {\n        font-size: 14px;\n    }\n\n    .category-title {\n        font-size: 16px;\n    }\n\n    .product-title {\n        font-size: 14px;\n    }\n\n    .product-price .amount {\n        font-size: 15px;\n    }\n\n    .add-btn {\n        width: 32px;\n        height: 32px;\n    }\n\n    .cart-summary .d-flex {\n        font-size: 14px;\n    }\n\n    .btn-primary {\n        padding: 14px 24px;\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 480px) {\n    .menu-header {\n        padding: 10px 12px;\n    }\n\n    .store-logo {\n        width: 28px;\n        height: 28px;\n    }\n\n    .store-name {\n        font-size: 13px;\n    }\n\n    .search-input {\n        padding: 10px 16px;\n        font-size: 16px;\n    }\n\n    .product-card .card-body {\n        padding: 12px;\n    }\n\n    .cart-view {\n        padding: 12px;\n    }\n\n    .cart-item .card-body {\n        padding: 12px;\n    }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n    .public-restaurant-menu {\n        background-color: #1a1a1a;\n        color: #ffffff;\n    }\n\n    .menu-header,\n    .product-card,\n    .cart-item {\n        background-color: #2d2d2d;\n        border-color: #404040;\n    }\n\n    .store-name,\n    .product-title,\n    .category-title {\n        color: #ffffff;\n    }\n\n    .text-muted {\n        color: #adb5bd !important;\n    }\n\n    .form-control {\n        background-color: #2d2d2d;\n        border-color: #404040;\n        color: #ffffff;\n    }\n\n    .form-control:focus {\n        background-color: #2d2d2d;\n        border-color: #007bff;\n        color: #ffffff;\n    }\n}\n\n/* Accessibility improvements */\n.btn:focus,\n.form-control:focus {\n    outline: 2px solid #007bff;\n    outline-offset: 2px;\n}\n\n/* Touch-friendly tap targets */\n/* .btn,\n.form-control,\n.badge {\n    min-height: 44px;\n    min-width: 44px;\n}\n\n.add-btn,\n.btn-sm {\n    min-height: 36px;\n    min-width: 36px;\n} */\n\n/* Smooth scrolling */\nhtml {\n    scroll-behavior: smooth;\n}\n\n/* Hide scrollbars but keep functionality */\n.overflow-auto::-webkit-scrollbar {\n    width: 0px;\n    background: transparent;\n}\n\n/* Animation for cart badge */\n.badge {\n    animation: pulse 0.3s ease-in-out;\n}\n\n@keyframes pulse {\n    0% {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(1.1);\n    }\n\n    100% {\n        transform: scale(1);\n    }\n}\n\n/* Sticky positioning for better UX */\n.sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n}\n\n/* Loading states */\n.btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Success states */\n.text-success {\n    color: #28a745 !important;\n}\n\n/* Error states */\n.text-danger {\n    color: #dc3545 !important;\n}\n\n/* Card hover effects */\n.card {\n    transition: all 0.2s ease-in-out;\n}\n\n.card:hover {\n    /* transform: translateY(-2px); */\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Modal improvements for mobile */\n@media (max-width: 576px) {\n    .modal-dialog {\n        margin: 0;\n        height: 100vh;\n        max-width: 100%;\n    }\n\n    .modal-content {\n        height: 100vh;\n        border-radius: 0;\n    }\n\n    .digitalMenuRoomModal>div>.modal-content {\n        height: 35%;\n    }\n\n    .modal-body {\n        padding: 20px 15px;\n    }\n}\n\n/* ==========================================================================\n   Mobile QR landing-page enhancements\n   ========================================================================== */\n\n@media (max-width: 768px) {\n    .public-restaurant-menu {\n        background-color: #ffffff;\n    }\n\n    .menu-header {\n        position: sticky;\n        top: 0;\n        padding: 12px 16px;\n        background: #ffffff;\n        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);\n        border-bottom: none;\n    }\n\n    .store-logo {\n        width: 40px;\n        height: 40px;\n        border-radius: 8px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n    }\n\n    .store-name {\n        font-size: 17px;\n        font-weight: 700;\n        color: #1a1a2e;\n    }\n\n    .menu-header .btn-link {\n        color: #4a4a68;\n        font-size: 18px;\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 50%;\n        background: #f8f9fa;\n        margin-right: 8px;\n    }\n\n    .menu-header .btn-link:last-child {\n        margin-right: 0;\n    }\n\n    .search-input {\n        border-radius: 12px;\n        border: 1px solid #e9ecef;\n        background: #ffffff;\n        padding: 13px 18px;\n        font-size: 16px;\n        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n    }\n\n    .category-pills {\n        position: sticky;\n        top: 66px;\n        z-index: 1010;\n        background: #ffffff;\n        padding: 12px 16px;\n        border-bottom: 1px solid #f1f3f5;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n    }\n\n    .category-pills .badge {\n        display: inline-flex;\n        align-items: center;\n        padding: 10px 16px;\n        font-size: 13px;\n        font-weight: 600;\n        color: #495057;\n        background: #f1f3f5;\n        border: 1px solid transparent;\n        transition: all 0.2s ease;\n        text-decoration: none;\n    }\n\n    .category-pills .badge:hover,\n    .category-pills .badge:active,\n    .category-pills .badge:focus {\n        color: #ffffff;\n        background: #007bff;\n        border-color: #007bff;\n    }\n\n    .menu-content {\n        padding: 16px;\n        padding-bottom: 100px;\n    }\n\n    .category-title {\n        font-size: 18px;\n        font-weight: 700;\n        color: #1a1a2e;\n        border-bottom: none;\n        margin-bottom: 12px;\n    }\n\n    .product-card {\n        border-radius: 14px;\n        border: 1px solid #f1f3f5;\n        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);\n        margin-bottom: 16px;\n        overflow: hidden;\n    }\n\n    .product-card .card-body {\n        padding: 14px;\n    }\n\n    .product-image img {\n        width: 72px;\n        height: 72px;\n        border-radius: 10px;\n        object-fit: cover;\n        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n    }\n\n    .product-title {\n        font-size: 15px;\n        font-weight: 700;\n        color: #1a1a2e;\n        line-height: 1.35;\n        margin-bottom: 6px;\n    }\n\n    .product-price .currency {\n        font-size: 12px;\n        color: #6c757d;\n    }\n\n    .product-price .amount {\n        font-size: 17px;\n        font-weight: 700;\n        color: #212529;\n    }\n\n    .add-btn {\n        width: 38px;\n        height: 38px;\n        border-radius: 10px;\n        font-size: 16px;\n        box-shadow: 0 2px 6px rgba(0, 123, 255, 0.25);\n    }\n\n    .add-btn:active {\n        transform: scale(0.95);\n    }\n\n    /* Floating cart bar */\n    .cart-fab-bar {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        padding: 12px 16px;\n        background: #ffffff;\n        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);\n        z-index: 1040;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        border-top: 1px solid #f1f3f5;\n    }\n\n    .cart-fab-bar .cart-info {\n        display: flex;\n        flex-direction: column;\n        color: #1a1a2e;\n    }\n\n    .cart-fab-bar .cart-items-count {\n        font-size: 13px;\n        color: #6c757d;\n    }\n\n    .cart-fab-bar .cart-total-amount {\n        font-size: 17px;\n        font-weight: 700;\n    }\n\n    .cart-fab-bar .btn-primary {\n        padding: 10px 22px;\n        border-radius: 10px;\n        font-weight: 700;\n        font-size: 15px;\n    }\n\n    .cart-view .cart-item .card-body {\n        padding: 16px;\n    }\n\n    .cart-summary {\n        border-radius: 14px;\n        background: #f8f9fa;\n        border: 1px solid #f1f3f5;\n        padding: 18px;\n        margin-bottom: 20px;\n    }\n\n    .cart-summary .d-flex:last-child {\n        border-top: 2px solid #dee2e6;\n        padding-top: 14px;\n    }\n\n    .form-control {\n        border-radius: 10px;\n        padding: 12px 14px;\n        font-size: 16px;\n        border: 1px solid #e9ecef;\n    }\n\n    .form-check-input {\n        width: 20px;\n        height: 20px;\n        margin-top: 0;\n    }\n\n    .form-check-label {\n        font-size: 14px;\n        margin-left: 4px;\n    }\n\n    .btn-primary {\n        border-radius: 12px;\n        padding: 14px;\n        font-size: 16px;\n        font-weight: 700;\n    }\n}\n\n@media (max-width: 576px) {\n    .menu-header {\n        top: 0;\n        padding: 10px 14px;\n    }\n\n    .category-pills {\n        top: 62px;\n        padding: 10px 14px;\n    }\n\n    .product-image img {\n        width: 60px;\n        height: 60px;\n    }\n\n    .product-title {\n        font-size: 14px;\n    }\n\n    .product-price .amount {\n        font-size: 16px;\n    }\n\n    .add-btn {\n        width: 36px;\n        height: 36px;\n    }\n}\n\n/* Hide the original header cart badge on mobile, the floating bar takes over */\n@media (max-width: 768px) {\n    .menu-header .cart-trigger-mobile {\n        display: none !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
